import React from 'react';
import { Button, Icon } from 'antd';
import StudentFilter from '../StudentFilter'
import ModalFilter from '../ModalFilter'
import DrawerFilter from '../DrawerFilter'
import ClassFilter from '../ClassFilter'
import { translate } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux'
import { firebaseConnect, isLoaded } from 'react-redux-firebase'
import { withRouter } from 'react-router'
import { addStudents, addTeachers, addClasses, addLogs, changeStudentFilter, changeProductFilter, changeClassFilter, changeProjectFilter, changeClass, yearChange, logYears } from '../../actions'
import * as R from 'ramda'
import moment from 'moment'

class TopBar extends React.Component {

  state = {
    studentModal: false,
    filterModal: false,
    classModal: false,
    grade: 'All',
    category: 'All',
    menuLocation: 'myclasses',
    filterType: '',
    drawerVisible: false
  }

  componentDidUpdate = (prevProps) => {
    const { academicYear, relevantLogs } = this.props
    const _this = this
    if (this.props.location.pathname !== prevProps.location.pathname) {
      let url = this.props.location.pathname.split('/')
      let menuLocation = url[1];
      let filterType;
      if (url.length == 3 && menuLocation !== 'school') {
        filterType = 'double'
      } else {
        filterType = 'single'
      }
      if (url.includes('individualprojects')) {
        filterType = 'individualprojects'
      }
      if (url.includes('servicetracker') && !url.includes('individualprojects')) {
        filterType = null
      }
      if (menuLocation == 'school' && url.length == 2) {
        this.props.history.push('/school/generalinfo')
      }
      this.setState({ menuLocation, filterType }, () => {
        _this.getUsers()
      })
    }

    if (!prevProps.dataLoaded && this.props.dataLoaded) {
      this.getUsers()
    }

    if (prevProps.users !== this.props.users) {
      this.getUsers()
    }

    if (prevProps.classFilter !== this.props.classFilter) {
      this.getUsers()
    }

    if (prevProps.year && prevProps.year.text !== this.props.year.text) {
      this.getUsers()
    }

    if (prevProps.allLogs && Object.keys(prevProps.allLogs).length !== Object.keys(this.props.allLogs).length) {
      this.getUsers()
    }
  }

  closeModal = (modal) => {
    if (modal == 'student') {
      this.setState({ studentModal: false })
    } else if (modal == 'filter') {
      this.setState({ filterModal: false })
    } else if (modal == 'drawer') {
      this.props.changeProjectFilter('name', '')
      this.props.changeProjectFilter('reaction', '')
      this.props.changeProjectFilter('type', '')
      this.props.changeProjectFilter('stage', '')
      this.setState({ drawerVisible: false })
    }
    else {
      this.setState({ classModal: false })
    }
  }


  submitModal = () => {
    this.props.changeProjectFilter('submit', true)
    this.setState({ drawerVisible: false })
  }

  resetFilters = () => {
    this.props.changeProjectFilter('name', '')
    this.props.changeProjectFilter('reaction', '')
    this.props.changeProjectFilter('type', '')
    this.props.changeProjectFilter('stage', '')
  }

  selectStudent = (id, name) => {

    this.props.changeStudentFilter(id, name)
  }

  selectProduct = (key) => {

    this.props.changeProductFilter(key)
  }

  setClassFilter = (type, value) => {
    this.props.changeClassFilter(type, value)
  }


  setProjectFilter = (type, value) => {
    this.props.changeProjectFilter(type, value)
  }

  closeClass = () => {
    this.props.changeClass('All')
    this.props.history.push(`/${this.state.menuLocation}`)
  }

  changeClass = (id, subject, name, grade, subjectId, students) => {
    this.props.changeClass(id, subject, name, grade, subjectId, students);
  };

  //The functions below are to gather basic data that's used on all pages

  getUsers = () => {
        //Put all students from this school to redux state
        let students;
        let users;
        let teachers;
        if (this.props.users && this.props.profile) {
          users = Object.entries(this.props.users);
          let schoolId = this.props.profile.profile.school.id

          students = users && users.filter(user =>
            user[1].profile.school
            &&
            Object.values(user[1].roles)[0][0] == 'student' && user[1].active == true
            &&
            user[1].profile.school.id == schoolId
          )
          teachers = users.filter(user =>
            Object.values(user[1].roles)[0][0] == 'teacher' && user[1].active == true
            &&
            user[1].profile.school.id == schoolId
          )
    
          this.props.addStudents(students)
          this.props.addTeachers(teachers)
          this.getLogs(students)
        }
  }

  getLogs = (students) => {
        //Put relevant (filtered) logs to redux state
        let logs;
        let filteredLogs = {};
        let logsArray;
        if (this.props.allLogs && this.props.studentFilter && students && this.props.studentFilter && this.props.selectedClass) {
          logs = Object.entries(this.props.allLogs)
          logs.map(log => (
            log[1].id = log[0]
          ))
          //Put school's student's id-s into an array
          let studentIds = [];
          students.map(student => studentIds.push(student[0]))
          //Filter logs made  by students of this school
          logs = logs.filter(log =>
            studentIds.includes(log[1].user_id)
          )
          //Student filter
          if (this.props.studentFilter.id != 'all') {
    
            filteredLogs = logs.map(log =>
              filteredLogs[log[0]] = log[1]
            )
            filteredLogs = filteredLogs.filter(log =>
              log.user_id == this.props.studentFilter.id
            )
          } else {
    
            filteredLogs = logs.map(log =>
              filteredLogs[log[0]] = log[1]
            )
          }
          //Class filter
          if (this.props.selectedClass.id !== 'All') {
            filteredLogs = filteredLogs.filter(log =>
              log.subject.id == this.props.selectedClass.subjectId
              &&
              this.props.selectedClass.students
              &&
              this.props.selectedClass.students.includes(log.user_id)
            )
          }
          // Subject filter
          if (this.props.classFilter.subject.name !== 'All') {
            filteredLogs = filteredLogs.filter(log =>
              log.subject.id == this.props.classFilter.subject.id
            )
          }
          //Subject category filter
          if (this.props.classFilter.category !== 'All' && this.props.allClasses) {
            //First find what subjects is under the subject group
            let subjectsInGroup = []
            Object.entries(this.props.allClasses).map(clss => {
              if (clss[1].subject_category == this.props.classFilter.category) {
                subjectsInGroup.push(clss[1].subject)
              }
            })
            filteredLogs = filteredLogs.filter(log =>
              subjectsInGroup.includes(log.subject.id)
            )
          }
          //Teacher filter
          if (this.props.classFilter.teacher.name !== 'All' && this.props.allClasses) {
            //1. Find subjects of the teacher
            let classes = Object.entries(this.props.allClasses)
            let subjectsOfTeacher = []
            classes.map(clss => {
              if (clss[1].teacher == this.props.classFilter.teacher.id) {
                subjectsOfTeacher.push(clss[1].subject)
              }
            })
            //2. Find students from those classes
            let studentsOfTeacher = []
            classes.map(clss => {
              if (clss[1].students) {
                studentsOfTeacher = studentsOfTeacher.concat(Object.keys(clss[1].students))
              }
            })
            //3. Filter the logs
            filteredLogs = filteredLogs.filter(log =>
              subjectsOfTeacher.includes(log.subject.id)
              &&
              studentsOfTeacher.includes(log.user_id)
            )
          }
    
          //Grade filter
          if (this.props.classFilter.grade !== 'All' && this.props.allClasses) {
            console.log('fitleredLogs', filteredLogs)
            // Find subjects and students in the grade
            let classes = Object.entries(this.props.allClasses)
            let studentsInGrade = []
            let subjectsInGrade = []
            if (this.props.year) {
              const { text, from, to } = this.props.year
              if (text === '2018 - 2019' || text === '2018') {
                classes = classes.filter(clss =>
                  !clss[1].createdAt
                )
              } else {
                classes = classes.filter(clss =>
                  clss[1].createdAt
                  &&
                  clss[1].createdAt > from
                  &&
                  clss[1].createdAt < to
                )
              }
            }
            classes.map(clss => {
              if (clss[1].grade == this.props.classFilter.grade) {
                if (clss[1].students) {
                  studentsInGrade = studentsInGrade.concat(Object.keys(clss[1].students))
                }
                subjectsInGrade.push(clss[1].subject)
              }
            })
            //Filter the logs made by these student
            filteredLogs = (studentsInGrade && subjectsInGrade) && filteredLogs.filter(log =>
              studentsInGrade.includes(log.user_id)
              &&
              subjectsInGrade.includes(log.subject.id)
            )
          } 
          this.addYears(filteredLogs)
        }
  }

  addYears = (filteredLogs) => {
    const { academicYear, year } = this.props
    const current_year = moment().format('YYYY')
    let classes = []
    if (this.props.allClasses) {
      classes = Object.entries(this.props.allClasses)
    }
    let allYears = []
    let i = 2018
    if (academicYear === 'August - July') {
      for (i; i<= current_year; i++) {
        let from = moment(`${i.toString()}08`, 'YYYYMM').valueOf()
        let to = moment(`${(i+1).toString()}08`, 'YYYYMM').valueOf()
        let logs_in_year = filteredLogs.filter( log => 
          moment(log.date).valueOf() > from 
          &&
          moment(log.date).valueOf() < to
        )
        let classes_in_year = classes.filter( clss => 
            (clss[1].createdAt > from && clss[1].createdAt < to)
            ||
            !clss[1].createdAt
          )
        if (logs_in_year.length > 0 || classes_in_year.length > 0 ) {
          allYears.push({
            from,
            to,
            text: `${i} - ${i+1}`
          })
        }
      }
      if (allYears.length == 0) {
        let from = moment(`${current_year.toString()}08`, 'YYYYMM').valueOf()
        let to = moment(`${current_year.toString()}08`, 'YYYYMM').valueOf()
        allYears.push({
          from,
          to,
          text: current_year
        })
      }

    } else {
      for (i; i<= current_year; i++) {
        let from = moment(i.toString(), 'YYYY').valueOf()
        let to = moment((i+1).toString(), 'YYYY').valueOf()
        let logs_in_year = filteredLogs.filter( log => 
          moment(log.date).valueOf() > from 
          &&
          moment(log.date).valueOf() < to
        )

        let classes_in_year = classes.filter( clss => 
          clss[1].createdAt > from && clss[1].createdAt < to
        )
        if (logs_in_year.length > 0 || classes_in_year.length > 0 ) {
          allYears.push({
            from,
            to,
            text: `${i}`
          })
        }
      }

      if (allYears.length == 0) {
        let from = moment(`${current_year.toString()}08`, 'YYYYMM').valueOf()
        let to = moment(`${current_year.toString()}08`, 'YYYYMM').valueOf()
        allYears.push({
          from,
          to,
          text: current_year
        })
      }
    }

    let logs_in_year;
    let currentYear = allYears[allYears.length - 1]
    let used_year;

    if (year) {
      logs_in_year = filteredLogs.filter( log => 
        moment(log.date).valueOf() > year.from 
        &&
        moment(log.date).valueOf() < year.to
      )
      used_year = year
    } else {
      logs_in_year = filteredLogs.filter( log => 
        moment(log.date).valueOf() > currentYear.from 
        &&
        moment(log.date).valueOf() < currentYear.to
      )
      used_year = currentYear
    }

    if (this.props.selectedClass.id !== 'All') {
      this.props.addLogs(filteredLogs)
    } else {
      this.props.addLogs(logs_in_year)
    }
    
    this.props.changeYear(used_year)
    this.props.addYears(allYears)
    this.getClasses(used_year)
  }

  getClasses = (used_year) => {
    //Put classes into redux state
    let classes;
    if (this.props.allClasses) {
      classes = Object.entries(this.props.allClasses)
      //If in my classes menu point, only show my classes
      if (this.state.menuLocation == 'myclasses') {
        classes = classes.filter(clss =>
          clss[1].teacher == this.props.uid
          ||
          (clss[1].teacher && typeof clss[1].teacher !== 'string' && clss[1].teacher.includes(this.props.uid))
        )
      }
      if (this.props.classFilter.category !== 'All') {
        classes = classes.filter(cls =>
          cls[1].subject_category == this.props.classFilter.category
        )
      }
      if (this.props.classFilter.grade !== 'All') {
        classes = classes.filter(cls =>
          cls[1].grade == this.props.classFilter.grade
        )
      }
      if (this.props.classFilter.subject.name !== 'All') {
        classes = classes.filter(cls =>
          cls[1].subject == this.props.classFilter.subject.id
        )
      }
      if (this.props.classFilter.teacher.name !== 'All') {
        classes = classes.filter(cls =>
          cls[1].teacher == this.props.classFilter.teacher.id
          ||
          (cls[1].teacher && typeof cls[1].teacher !== 'string' && cls[1].teacher.includes(this.props.classFilter.teacher.id))
        )
      }

      if (used_year.text === '2018 - 2019' || used_year.text === '2018') {
        classes = classes.filter( clss => 
          !clss[1].createdAt
        )
      } else {
        classes = classes.filter( clss => 
          clss[1].createdAt
          &&
          clss[1].createdAt > used_year.from 
          &&
          clss[1].createdAt < used_year.to 
        )
      }     
      this.props.addClasses(classes)

      //Find students of selected class
      if (classes && this.props.selectedClass && this.props.selectedClass.id !== 'All') {
        classes = classes.filter(clss =>
          clss[0] == this.props.selectedClass.id
        )
        this.props.addClasses(classes[0])
      }
    }
}

  render() {

    const { t, teachers, students } = this.props;

    if (!this.props.visibility) {
      return (<div style={{ display: 'none' }}></div>)
    }

    return (
      <div style={styles.container}>
        <div style={{width: 'max-width', display: 'table-row'}}>
          {this.props.studentFilter.id != 'all' &&
            <Button
              style={styles.button}
              onClick={() => this.props.changeStudentFilter('all')}
            >
              {this.props.studentFilter.name} x
          </Button>
          }
          {this.props.classFilter.grade != 'All' &&
            <Button
              style={styles.button}
              onClick={() => this.props.changeClassFilter('grade', 'All')}
            >
              {t('Grade')}: {this.props.classFilter.grade} x
          </Button>
          }
          {this.props.classFilter.category != 'All' &&
            <Button
              style={styles.button}
              onClick={() => this.props.changeClassFilter('category', 'All')}
            >
              {t('Subject group')}: {this.props.classFilter.category} x
          </Button>
          }
          {this.props.classFilter.subject.name != 'All' &&
            <Button
              style={styles.button}
              onClick={() => this.props.changeClassFilter('subject', { id: '', name: 'All' })}
            >
              {t('Subject')}: {this.props.classFilter.subject.name} x
          </Button>
          }
          {this.props.selectedClass && this.props.selectedClass.id != 'All' &&
            <Button
              style={styles.button}
              onClick={() => this.closeClass()}
            >
              {t('Class')}: {`${this.props.selectedClass.grade} ${this.props.selectedClass.subject} (${this.props.selectedClass.name})`} x
          </Button>
          }
          {this.props.classFilter && this.props.classFilter.teacher.name != 'All' &&
            <Button
              style={styles.button}
              onClick={() => this.props.changeClassFilter('teacher', { id: '', name: 'All' })}
            >
              {t('Teacher')}: {this.props.classFilter.teacher.name} x
          </Button>
          }
        </div>


        {this.state.filterType == 'single' &&
          <div style={{marginLeft: 'auto'}}>
            <Button
              style={styles.buttonBlue} type="primary"
              onClick={() => this.setState({ filterModal: true })}
            >
              <Icon type="bar-chart" /> {t('Filter')}
            </Button>

            <ModalFilter
              isOpen={this.state.filterModal}
              close={() => this.closeModal('filter')}
              classes={this.props.allClasses}
              setFilter={this.setClassFilter}
              filters={this.props.classFilter}
              subjects={this.props.subjects}
              teachers={teachers}
              location={this.props.location.pathname}
            />
          </div>
        }
        {this.state.filterType == 'double' &&
          <div style={{ overflow: 'hidden', width: 'max-content', marginLeft: 'auto' }}>
            <Button
              style={styles.buttonBlue} type="primary"
              onClick={() => this.setState({ studentModal: true })}
            >
              <Icon type="team" /> {t('Students')}
            </Button>
            <Button
              id="classes"
              style={styles.buttonBlue} type="primary"
              onClick={() => this.setState({ classModal: true })}
            >
              <Icon type="team" /> {t('Classes')}
            </Button>

            <StudentFilter
              students={students}
              isOpen={this.state.studentModal}
              close={() => this.closeModal('student')}
              selectStudent={(id, name) => this.selectStudent(id, name)}
              selectedStudent={this.props.studentFilter}
            />
            <ClassFilter
              isOpen={this.state.classModal}
              close={() => this.closeModal('class')}
              classes={this.props.allClasses}
              changeClass={this.changeClass}
              selectedClass={this.props.selectedClass}
              subjects={this.props.subjects}
            />
          </div>
        }

        {this.state.filterType == 'individualprojects' &&
          <div style={{width: '100%'}}>
            <Button
              style={styles.buttonBlue} type="primary"
              onClick={() => this.setState({ drawerVisible: !this.state.drawerVisible })}
            >
              <Icon type="bar-chart" /> {t('Filter')}
            </Button>
            <DrawerFilter
              filters={this.props.projectFilter}
              visible={this.state.drawerVisible}
              close={() => this.closeModal('drawer')}
              submit={() => this.submitModal()}
              setFilter={this.setProjectFilter}
              resetFilters={this.resetFilters}
            />
          </div>
        }
      </div>
    )
  }
}


function mapDispatchToProps(dispatch) {
  return ({
    changeStudentFilter: (id, name) => { dispatch(changeStudentFilter(id, name)) },
    changeProductFilter: (key) => { dispatch(changeProductFilter(key)) },
    changeClassFilter: (type, value) => { dispatch(changeClassFilter(type, value)) },
    changeProjectFilter: (type, value) => { dispatch(changeProjectFilter(type, value)) },
    addStudents: (students) => { dispatch(addStudents(students)) },
    addClasses: (classes) => { dispatch(addClasses(classes)) },
    addTeachers: (teachers) => { dispatch(addTeachers(teachers)) },
    addLogs: (logs) => { dispatch(addLogs(logs)) },
    changeClass: (id, subject, name, grade, subjectId, students) => { dispatch(changeClass(id, subject, name, grade, subjectId, students)) },
    addYears: (years) => {dispatch(logYears(years))},
    changeYear: (year, allYears) => {dispatch(yearChange(year, allYears))}
  })
}
const enhancer = compose(
  translate('lang'),
  firebaseConnect((props, store) => {
    const state = store.getState()
    const schoolId = R.path(['firebase', 'profile', 'profile', 'school', 'id'], state)
    const paths = ['users', 'profile', 'logs', 'subjects']
    if (schoolId) {
      paths.push(`/schools/${schoolId}`);
    }
    return paths;
  }),
  connect(
    state => {
      const dataLoaded = isLoaded(state.firebase.data.logs) && isLoaded(state.firebase.data.users) && isLoaded(state.firebase.data.schools) && isLoaded(state.firebase.data.subjects)
      const schoolId = R.path(['profile', 'profile', 'school', 'id'], state.firebase)
      console.log('schoolId' ,schoolId)
      return {
        dataLoaded,
        users: state.firebase.data.users,
        studentFilter: state.studentFilter,
        profile: state.firebase.profile,
        allLogs: state.firebase.data.logs,
        allClasses: state.firebase.data.schools && state.firebase.data.schools[schoolId].classes,
        academicYear: state.firebase.data.schools && state.firebase.data.schools[schoolId] ? R.pathOr('August - July', ['schools', schoolId, 'academicYear'], state.firebase.data) : false,
        classFilter: state.classFilter,
        relevantLogs: state.relevantLogs.logs,
        projectFilter: state.projectFilter,
        subjects: state.firebase.data.subjects,
        selectedClass: state.selectedClass,
        teachers: state.teachersOfSchool.teachers,
        students: state.studentsOfSchool.students,
        year: state.currentYear && state.currentYear.year
      }
    },
    mapDispatchToProps
  )
)
export default withRouter(enhancer(TopBar))


const styles = {

  container: {
    padding: '10px 20px 10px 20px',
    width: '100%',
    minHeight: 53,
    display: 'flex'
  },

  button: {
    borderRadius: '15px',
    fontSize: '17px',
    fontWeight: 600,
    backgroundColor: '#D9E3EB',
    border: 'none',
    marginLeft: '5px'
  },

  buttonBlue: {
    float: 'right',
    fontSize: '17px',
    backgroundColor: '#4A90E2',
    border: 'none',
    fontSize: '14px',
    borderRadius: '15px',
    marginLeft: 'auto'
  }
}



// WEBPACK FOOTER //
// ./src/components/TopBar/index.jsx